import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Check, Lock } from "lucide-react";

export default function ChurchBuilderTemplates() {
  const [tpls, setTpls] = useState([]);
  useEffect(() => { api.get("/church-builder/templates").then((r) => setTpls(r.data)); }, []);

  return (
    <div data-testid="cb-templates" className="bg-[#0A0A0A] text-white">
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        <div className="label-eyebrow mb-3">Templates</div>
        <h1 className="font-serif-display text-5xl">Choose your <span className="italic text-[#D4AF37]">starting point</span>.</h1>
        <p className="text-neutral-300 mt-4 max-w-2xl">Three professionally designed templates — switch any time without losing content.</p>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {tpls.map((t) => (
            <div key={t.id} data-testid={`tpl-card-${t.id}`} className="luxury-card rounded-xl overflow-hidden">
              <div className="aspect-[4/3] overflow-hidden relative">
                <img src={t.preview_image_url} alt={t.name} className="w-full h-full object-cover" />
                {!t.available && (
                  <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
                    <div className="text-center">
                      <Lock size={20} className="text-[#D4AF37] mx-auto" />
                      <div className="text-[10px] tracking-widest uppercase text-[#D4AF37] mt-2">Coming Phase 1B</div>
                    </div>
                  </div>
                )}
              </div>
              <div className="p-6">
                <div className="font-serif-display text-2xl">{t.name}</div>
                <div className="text-xs tracking-widest text-[#D4AF37] uppercase mt-1">{t.tagline}</div>
                <p className="text-sm text-neutral-400 mt-3 leading-relaxed">{t.description}</p>
                <div className="mt-4 flex flex-wrap gap-1">
                  {(t.suitable_for || []).map((s) => (
                    <span key={s} className="px-2 py-0.5 text-[9px] tracking-widest uppercase rounded border border-white/15 text-neutral-300">{s}</span>
                  ))}
                </div>
                {t.available ? (
                  <Link to={`/church-builder/register?template=${t.id}`} data-testid={`tpl-pick-${t.id}`} className="btn-gold mt-6 w-full inline-flex justify-center px-4 py-2.5 rounded text-xs tracking-widest uppercase font-semibold">
                    Start with this template
                  </Link>
                ) : (
                  <button disabled className="mt-6 w-full px-4 py-2.5 rounded text-xs tracking-widest uppercase border border-white/10 text-neutral-500">Available soon</button>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
